import React, { useEffect, useState } from "react";
import {
  IconButton,
  TextField,
  Tooltip,
  Paper,
  Typography,
  Popper
} from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import "./selectWithSearch.less";

export default function SelectWithSearch({
  labelHeading = "",
  keyValue = "",
  isRequired = false,
  disabled = false,
  toolTip = "",
  id = "",
  txtName = "",
  onChange = () => {},
  optionsList = [],
  keyForMapping = "StateName",
  clearFilterData = false,
  defaultValue = null,
  reloadData = false
}) {
  const [selectedOptions, setSelectedOptions] = useState("");
  useEffect(() => {
    setSelectedOptions("");
  }, [clearFilterData]);
  useEffect(() => {
    setSelectedOptions(defaultValue);
  }, [reloadData]);

  /** call on input change */
  const onInputChange = (keyValue, value) => {
    setSelectedOptions(value);
    onChange(keyValue, value[keyForMapping]);
  };

  /** popper */
  const PopperMy = function(props) {
    return <Popper {...props} style={styles.popper} placement={"top-start"} />;
  };
  const styles = () => ({
    popper: {
      width: "fit-content"
    }
  });
  return (
    /**Added option for auto selecting value as typed for Automation Issue */
    <Autocomplete
      PopperComponent={PopperMy}
      autoSelect
      autoHighlight
      autoSave
      className={"search-box-wrapper"}
      size={"small"}
      underlineStyle={{ display: "none" }}
      onChange={(event, value) =>
        keyValue ? onInputChange(keyValue, value) : onChange(event)}
      PaperComponent={({ children }) => (
        <Paper style={{ fontSize: "1rem !important" }}>{children}</Paper>
      )}
      id={"tags-standard"}
      value={selectedOptions || ""}
      options={optionsList || []}
      //.map((option) => option[keyForMapping])}
      getOptionLabel={option => option[keyForMapping]}
      renderOption={option => (
        <Typography style={{ fontSize: "1rem" }}>
          {option[keyForMapping]}
        </Typography>
      )}
      renderInput={params => (
        <TextField
          {...params}
          autoComplete={"off"}
          inputProps={{ ...params.inputProps, style: { fontSize: "5rem" } }}
          InputLabelProps={{ style: { pointerEvents: "auto" } }}
          id={id}
          name={txtName}
          label={
            <div className={"labelWidth"}>
              <span>
                {" "}
                <b>{labelHeading} </b>
              </span>

              {isRequired && <span className={"requiredFldText"}>{" *"}</span>}
              {toolTip && (
                <Tooltip title={toolTip}>
                  <IconButton
                    id={"iconBtn"}
                    size={"small"}
                    className={"tooltip-iconSize"}
                  >
                    <InfoOutlined fontSize={"inherit"} />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          }
          disabled={disabled}
        />
      )}
    />
  );
}
